import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.scss'],
  standalone: false
})
export class CheckboxInputComponent {

  @Input()
  public label: string;

  @Input()
  public control: FormControl = new FormControl();

}
